import React from 'react';
import { Button, DatePicker, Select } from '@douyinfe/semi-ui';

/**
 * 日志筛选工具栏组件
 */
const FilterToolbar = ({
    dateRange,
    setDateRange,
    modelFilter,
    setModelFilter,
    streamFilter,
    setStreamFilter,
    availableModels,
    onFilterChange
}) => {
    const handleDateChange = (dates) => {
        setDateRange(dates);
        onFilterChange?.();
    };

    const handleModelChange = (value) => {
        setModelFilter(value || '');
        onFilterChange?.();
    };

    const handleStreamChange = (value) => {
        setStreamFilter(value);
        onFilterChange?.();
    };

    const handleReset = () => {
        setDateRange(null);
        setModelFilter('');
        setStreamFilter('all');
        onFilterChange?.();
    };

    const hasFilters = dateRange || modelFilter || streamFilter !== 'all';

    const datePresets = (() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const endOfToday = new Date();
        endOfToday.setHours(23, 59, 59, 999);
        return [
            { text: '今天', start: today, end: endOfToday },
            { text: '近7天', start: new Date(today.getTime() - 6 * 24 * 3600 * 1000), end: endOfToday },
            { text: '近30天', start: new Date(today.getTime() - 29 * 24 * 3600 * 1000), end: endOfToday },
        ];
    })();

    return (
        <div className="query-logs-filters">
            {/* 日期范围 */}
            <DatePicker 
                type="dateRange"
                density="compact"
                placeholder={['开始日期', '结束日期']}
                value={dateRange}
                onChange={handleDateChange}
                presets={datePresets}
                style={{ width: 240 }}
            />
            
            {/* 模型筛选 */}
            <Select
                placeholder="全部模型"
                value={modelFilter || undefined}
                onChange={handleModelChange}
                onClear={() => handleModelChange('')}
                allowClear
                filter
                style={{ width: 200 }}
                optionList={availableModels.map(model => ({ value: model, label: model }))}
                emptyContent={<span style={{ color: 'var(--text-tertiary)', fontSize: 12 }}>查询后显示模型</span>}
            />
            
            {/* 流/非流筛选 */}
            <div className="query-stream-toggle">
                <Button 
                    size="small"
                    type={streamFilter === 'all' ? 'secondary' : 'tertiary'}
                    onClick={() => handleStreamChange('all')}
                >
                    全部
                </Button>
                <Button 
                    size="small"
                    type={streamFilter === 'stream' ? 'secondary' : 'tertiary'}
                    onClick={() => handleStreamChange('stream')}
                >
                    流式
                </Button>
                <Button 
                    size="small"
                    type={streamFilter === 'non-stream' ? 'secondary' : 'tertiary'}
                    onClick={() => handleStreamChange('non-stream')}
                >
                    非流
                </Button>
            </div>
            
            {/* 重置筛选 */}
            {hasFilters && (
                <Button 
                    size="small" 
                    type="tertiary"
                    className="query-logs-reset"
                    onClick={handleReset}
                >
                    重置
                </Button>
            )}
        </div>
    );
};

export default FilterToolbar;
